import options from './motion.component';


export default {
    selector: "dtEmulatorMotion",
    options
}